<template>
  <!-- @TODO: usi only iso lang name ('en', ..) to set/change languages -->
  <div id="app">
    <TopNavbar :title="title" @langChange="changeLangByIso"></TopNavbar>
    <!-- <IgBreadcrumbs v-if="user"></IgBreadcrumbs> -->
    <div class="container" v-if="siteCfg == null">
      No sitecfg yet
    </div>
    <div v-else-if="appCfg != null && siteCfg != null" class="">
      <router-view />
    </div>
    <div class="section" v-else>
      <div class="notification">
        Config missing. Please wait or reload page.
      </div>
      <b-loading :is-full-page="false" :can-cancel="false"></b-loading>
    </div>
    <div class="footer">
      &nbsp;
    </div>
  </div>
</template>

<script>
import axios from "axios";
import(/* webpackChunkName: "IgCss1" */ "./scss/igapp.scss");

import { loadLocaleMessagesAsync } from "@/i18n";
import {
  setDocumentDirectionByLocale,
  setDocumentTitle,
  setDocumentLang
} from "@/util/i18n/doc";

import TopNavbar from "@/components/TopNavbar.vue";
// import IgBreadcrumbs from "@/components/IgBreadcrumbs.vue";

export default {
  name: "app",
  components: {
    TopNavbar
    // IgBreadcrumbs
  },
  data() {
    return {
      title: "iguestapp",
      isLoading: false,
      authTm: null
    };
  },
  created: function() {
    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          // if you ever get an unauthorized, logout the user
          // this.$store.dispatch(AUTH_LOGOUT);
          console.log("loggedOut?!");
          setTimeout(function() {
            window.location.href = "/login";
          }, 5000);

          // you can also redirect to /login if needed !
        }
        throw err;
      });
    });
  },
  mounted() {
    this.$store.dispatch("guicms/GET_SITECFG");
    this.$store.dispatch("guicms/GET_APPCFG");
    this.$store.dispatch("guicms/GET_CHPL");
    setTimeout(() => {
      this.getMgrAppCfg();
    }, 200);
    this.checkAuth();
    this.authTm = setInterval(() => {
      this.checkAuth();
    }, 300000);
  },
  computed: {
    siteCfg() {
      return this.$store.getters["guicms/SITECFG"];
    },
    appCfg() {
      return this.$store.getters["guicms/APPCFG"];
    },
    user() {
      return this.$store.getters["guicms/USER"];
    }
  },
  methods: {
    async getMgrAppCfg() {
      try {
        let { data } = await this.$api1().get("/mgrapp/cfg");
        console.log("got.mgrapp.cfg");
        if (!data.hasOwnProperty("forceIsoLangs")) {
          return;
        }
        let lStr = data.forceIsoLangs;
        if (lStr.trim() == "") return;
        let lAr = lStr.split(",");
        this.changeLangByIso(lAr[0]);
      } catch (e) {
        console.log("mgrapp.cfg.x: " + e.message);
      }
    },
    checkAuth() {
      this.$store.dispatch("guicms/USER_GET");
    },
    changeLangById(id) {
      //mame v jazykoch taky locale?
      console.log("changeLangById: " + id);
      let lang = this.$store.getters["guicms/LANG"](id);
      if (lang == null) {
        console.log("lang not found: " + id);
        return false;
      }
      this.$store.commit("guicms/SET_LANGID", id);
      let ll = lang.isoLangs.split(",");
      // console.log('isoLangs.ll='+ll);
      if (!ll || ll.length < 1) {
        console.log("er: no isoLang for lang: " + id);
        return false;
      }
      let lcid = ll[0];
      this.isLoading = true;
      loadLocaleMessagesAsync(lcid).then(() => {
        setDocumentLang(lcid);
        setDocumentDirectionByLocale(lcid);
        setDocumentTitle(this.$t("app.title"));
        this.isLoading = false;
      });
      return true;
    },
    changeLangByIso(isoCode) {
      console.log("changeLangByIso: " + isoCode);
      let lang = this.$store.getters["guicms/LANGBYISO"](isoCode);
      if (lang == null) {
        console.log("lang not found: " + isoCode);
        return false;
      }
      this.$store.commit("guicms/SET_LANGID", lang.id);
      let ll = lang.isoLangs.split(",");
      if (!ll || ll.length < 1) {
        console.log("er: no isoLang for lang: " + lang.id);
        return false;
      }
      let lcid = ll[0];
      this.isLoading = true;
      loadLocaleMessagesAsync(lcid).then(() => {
        setDocumentLang(lcid);
        setDocumentDirectionByLocale(lcid);
        setDocumentTitle(this.$t("app.title"));
        this.isLoading = false;
      });
      return true;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
